import React from 'react'
import styled from 'styled-components'
import { Header } from '@quotatisgroup/uikit-public.ui.header'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import { Button } from '@quotatisgroup/uikit-public.ui.button'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import cloudinary from 'utils/cloudinary'
import PropTypes from 'prop-types'
import AccountButton from './AccountButton/AccountButton'
import { UNIVERSES } from 'constants/routes'

const UniverseLinkMarginLeftAuto = styled(UniverseLink)`
  margin-left: auto;
  margin-right: 25px;
`

const HeaderSection = ({ layout, translate, isLoggedIn, proLogout }) => {
  const primaryCtaLink = layout === 'main' ? '/' : '/inscription-artisan-poseur'
  const primaryCtaText =
    layout === 'main'
      ? translate('header.global.cta')
      : translate('header.pro.cta')
  return (
    <Header
      srcLogo={cloudinary('/vitrine/logo/logo_baseline.svg')}
      altLogo={translate('pages.home.title')}
    >
      <Col sm="12" md="8" hasVerticalAlignForDesktop>
        <a id="header-logo-link" href="https://www.quotatis.fr">
          <Image
            isBlock
            src={cloudinary('/vitrine/logo/logo_baseline.svg')}
            alt={translate('pages.home.title')}
            mdMargin="right-md"
          />
        </a>
        <UniverseLink
          id="header-lecoindespros-link"
          href="https://lecoindespros.quotatis.fr/"
          isBold
          color="black"
          mdMargin="right-md"
        >
          {translate('access.link.procorner')}
        </UniverseLink>
        <UniverseLink
          id="header-actualites-link"
          href="https://lecoindespros.quotatis.fr/actualites/"
          isBold
          color="black"
          mdMargin="right-md"
        >
          {translate('access.link.actuality')}
        </UniverseLink>
        {isLoggedIn && (
          <UniverseLink
            id="header-packages-link"
            href="https://lecoindespros.quotatis.fr/forfaits/"
            isBold
            color="black"
            mdMargin="right-md"
          >
            {translate('access.link.packages')}
          </UniverseLink>
        )}
        <UniverseLink
          id="header-help-link"
          href="https://lecoindespros.quotatis.fr/help-center/"
          isBold
          color="black"
          mdMargin="right-md"
        >
          {translate('access.link.help')}
        </UniverseLink>
      </Col>
      <Col sm="12" hasVerticalAlignForDesktop>
        <UniverseLinkMarginLeftAuto
          id="header-primary-link"
          universe={UNIVERSES.PRO}
          path={primaryCtaLink}
        >
          {!isLoggedIn && (
            <Button id="header-primary" variant="primary" size="md">
              {primaryCtaText}
            </Button>
          )}
        </UniverseLinkMarginLeftAuto>
        <AccountButton />
        {isLoggedIn && (
          <Button
            id="header-logout"
            variant="primary"
            icon="power"
            size="md"
            handleClick={proLogout}
          >
            {translate('pro.header.logout')}
          </Button>
        )}
      </Col>
    </Header>
  )
}

HeaderSection.defaultProps = {
  layout: 'main',
}

HeaderSection.propTypes = {
  layout: PropTypes.string,
  translate: PropTypes.func,
  isLoggedIn: PropTypes.bool,
}

export default HeaderSection
